import {
  fetchProfileData,
  fetchAllPlans,
  addDslConnectionDetail,
  addDiConnectionDetail,
  updateDslConnectionDetail,
  fetchLead,
  checkOftFeasibility,
  sendOtp,
  createLeadHTTP,
  createLeadforAuth,
  submitlead,
  submitSiebelLead,
  submitTalkToEpert,
  getCities,
  checkOftFeasibilityDedicated,
  sendQuote,
  getLeadToken,
  needAssistance,
  getHistory,
  submitclarity,
  fetchPricing,
  getLeadByLeadId,
  cancelOrder,
  submitOrder,
  getRouterDetails,
  getCommercialAttributes,
  cancelLead,
  sendProposal,
  getOffers,
  loginSendOtp,
  VerifyOtp
} from '../services/http.service';

export const createLead = (payload, params, isdedicatedJourney) => {
  const promise = new Promise((resolve, reject) => {
    createLeadHTTP(payload, params, isdedicatedJourney).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
export const leadCreate = (headers, isdedicatedJourney, payload) => {
  const promise = new Promise((resolve, reject) => {
    createLeadforAuth(headers, isdedicatedJourney, payload).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const submitExpert = (payload, isdedicatedJourney) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      submitTalkToEpert(payload, isdedicatedJourney).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};
export const createSiebelLead = (isdedicatedJourney, auth_token = null) => {
  const promise = new Promise((resolve, reject) => {
    submitSiebelLead(isdedicatedJourney, auth_token).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const getCity = () => {
  const promise = new Promise((resolve, reject) => {
    getCities().then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const fetchUserProfileData = (payload) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      fetchProfileData(payload).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};

export const fetchLeadDetail = (isdedicatedJourney) => {
  const promise = new Promise((resolve, reject) => {
    fetchLead(isdedicatedJourney).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const fetchPlans = (params, isdedicatedJourney, token) => {
  const promise = new Promise((resolve, reject) => {
    fetchAllPlans(params, isdedicatedJourney, token).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const addDslConnectionDetails = (payload) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      addDslConnectionDetail(payload).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};

export const addDiConnectionDetails = (payload) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      addDiConnectionDetail(payload).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};

export const submitLeadDetails = (isdedicatedJourney) => {
  const promise = new Promise((resolve, reject) => {
    submitlead(isdedicatedJourney).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const updateDslConnectionDetails = (payload) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      updateDslConnectionDetail(payload).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};

export const checkOftFeasibilityStatus = (payload) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      checkOftFeasibility(payload).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};

export const checkOftFeasibilityStatusDedicated = (params, isAddFeasibility = false, isReuse = false) => {
  const promise = new Promise((resolve, reject) => {
    if (params) {
      checkOftFeasibilityDedicated(params, isAddFeasibility, isReuse).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};
export const sendOtpData = (payload) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      sendOtp(payload).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};
export const sendQuotation = (payload) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      sendQuote(payload).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};
export const getLeadTokenVale = (payload, orderId) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      getLeadToken(payload, orderId).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};
export const submitNeedAssistance = (payload, isMultiSite) => {
  const promise = new Promise((resolve, reject) => {
    if (payload) {
      needAssistance(payload, isMultiSite).then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    }
  });
  return promise;
};
export const getClarityHistory = (reqObj) => {
  const promise = new Promise((resolve, reject) => {
    getHistory(reqObj).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
export const submitClarity = (reqObj, token) => {
  const promise = new Promise((resolve, reject) => {
    submitclarity(reqObj, token).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
export const getPlansForKAM = (reqObj, token) => {
  const promise = new Promise((resolve, reject) => {
    fetchPricing(reqObj, token).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const getSavedPlan = (reqObj, token) => {
  const promise = new Promise((resolve, reject) => {
    getLeadByLeadId(reqObj, token).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const submitKamOrder = (reqObj, token) => {
  const promise = new Promise((resolve, reject) => {
    submitOrder(reqObj, token).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const cancelKamOrder = (reqObj, token) => {
  const promise = new Promise((resolve, reject) => {
    cancelOrder(reqObj, token).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
export const getRouterList = () => {
  const promise = new Promise((resolve, reject) => {
    getRouterDetails().then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
export const getCommercialAttributesList = (reqObj) => {
  const promise = new Promise((resolve, reject) => {
    getCommercialAttributes(reqObj).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
export const cancelCustomerLead = (payLoad, isdedicatedJourney) => {
  const promise = new Promise((resolve, reject) => {
    cancelLead(payLoad, isdedicatedJourney).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
export const sendPricingProposal = (paylod) => {
  const promise = new Promise((resolve, reject) => {
    sendProposal(paylod).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const getOfferList = (params = null) => {
  const promise = new Promise((resolve, reject) => {
    getOffers(params).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const getLoginOtp = (data) => {
  const promise = new Promise((resolve, reject) => {
    loginSendOtp(data).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export const loginOtpVerify = (data, params) => {
  const promise = new Promise((resolve, reject) => {
    VerifyOtp(data, params).then(
      (res) => {
        resolve(res);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};
